import type { TermAndCondition } from '../types/timeSlots';

/**
 * Filter slot-level terms by selected time and area.
 *
 * Matches legacy AngularJS behaviour (personalize.js:58-70):
 * 1. Filter by time: keep terms whose `times` array includes selectedTime
 *    (or terms with an empty `times` array, which apply to all times).
 * 2. Area priority: if area-specific terms exist, use them exclusively;
 *    otherwise fall back to generic terms (no area).
 */
export function filterTerms(
  terms: TermAndCondition[],
  selectedTime: string | null,
  selectedAreaId: number | null,
): TermAndCondition[] {
  // Step 1: Filter by time
  let filtered = terms;
  if (selectedTime) {
    filtered = terms.filter(t => t.times.length === 0 || t.times.includes(selectedTime));
  }

  // Step 2: Area priority
  if (selectedAreaId != null) {
    const areaSpecific = filtered.filter(t => t.area === selectedAreaId);
    if (areaSpecific.length > 0) return areaSpecific;
  }

  // Fallback: generic terms (no area)
  return filtered.filter(t => !t.area);
}
